(function () {
  function setHeaderOffset() {
    var headerMain = document.querySelector('[data-site-header-main]');
    if (headerMain) {
      document.documentElement.style.setProperty(
        '--site-header-main-height',
        headerMain.offsetHeight + 'px'
      );
    }
  }

  setHeaderOffset();
  window.addEventListener('load', setHeaderOffset);
  window.addEventListener('resize', setHeaderOffset);
})();